import React from 'react';
import { ReactComponent as SVG } from '@/assets/icons/minus-outline.svg';
import { IconProps, applySizeToProps } from './index';

export const IconMinusOutline: React.FC<IconProps> = (props) => {
  return <SVG {...applySizeToProps(props)} />;
};
